module.exports = __webpack_public_path__ + "fonts/droid-sans-mono.54fd854.woff2";